<template>
    <div>
        <div class="container-fluid">
            <div class="d-block pt-5">
                <div class="row row-sm-mobile">
                    <div class="col-lg-6 col-md-12 mb-4">
                        <div class="d-flex flex-column h-100">
                            <div class="d-block flex-1 mb-lg-0 mb-4">
                                <div class="h1-lg display-tektur">Dashboard</div>
                            </div>
                            <div class="d-flex align-items-center pb-3 border-bottom">
                                <div class="d-block me-3">
                                    <div class="avatar">
                                        <span class="avatar-title rounded-circle bg-pink text-dark"><i
                                                class="fa-solid fa-school fa-lg m-0"></i></span>
                                    </div>
                                </div>
                                <div class="d-block overflow-hidden">
                                    <div class="d-block h2 font-bold mb-2 block-ellipsis">{{ school_info.name }}</div>
                                    <div class="d-block">{{ school_info.address }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb-4">
                        <div class="card px-2 h-100 m-0">
                            <div class="card-body h-100">
                                <div class="d-block text-center font-bold mb-3">Jumlah Siswa Aktif</div>
                                <div class="d-block text-xlg display-tektur text-center text-neon mb-4">
                                    {{statistic_student.total_student}}
                                </div>
                                <div class="d-flex text-center mb-2 justify-content-center">
                                    <button class="btn btn-sm btn-s-1 btn-white mr-5" type="button"
                                        v-on:click="goToPage('student')">
                                        <div class="btn-s-1-inner">Lihat Siswa<i
                                                class="fa-solid fa-arrow-right ms-2"></i></div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb-4">
                        <div class="card px-2 h-100 m-0">
                            <div class="card-body h-100">
                                <div class="d-block text-center font-bold mb-3">Diterima di Universitas</div>
                                <div class="d-block text-xlg display-tektur text-center text-neon mb-4">
                                    {{statistic_student.total_alumni}}
                                </div>
                                <div class="d-block text-center mb-2">
                                    <button class="btn btn-sm btn-s-1 btn-white" type="button"
                                        v-on:click="goToPage('school_pg_alumni')">
                                        <div class="btn-s-1-inner">Lihat Siswa<i
                                                class="fa-solid fa-arrow-right ms-2"></i></div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-md-4">
                    <div class="col-lg-3 col-md-6 mb-lg-0 mb-3" v-for="(item, index) in statistic_graduation" :key="index">
                        <div class="card bg-card-trans-2 mb-0 lift">
                            <div class="card-body">
                                <div class="d-block text-center h2 mb-4">{{ item.year }}</div>
                                <!-- <div id="year1" class="circle-progress-wrap text-center"></div> -->
                                <div class="d-block pt-4">
                                    <div
                                        class="d-flex align-items-center justify-content-between overflow-hidden text-sm pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Eligible</div>
                                        <div class="text-right font-bold">{{ item.total_eligible }}</div>
                                    </div>
                                    <div
                                        class="d-flex align-items-center justify-content-between overflow-hidden text-sm pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Lolos</div>
                                        <div class="text-right font-bold">{{ item.total_passed }}</div>
                                    </div>
                                </div>
                                <div class="d-block" style="width:100% !important;">
                                    <DoughnutChart :chart-data="item.doughcart" />

                                    <div 
                                        v-for="item_detail in item.detail" 
                                        :key="item_detail.id"
                                        class="d-inline-flex align-items-center me-3"
                                        style="margin-top:0px !important;"
                                    >
                                        <!-- Kotak Warna -->
                                        <div 
                                            :style="{ backgroundColor: item_detail.bgcolor }"
                                            class="rounded"
                                            style="width: 15px; height: 15px; border: 1px solid #ccc;"
                                        ></div>

                                        <span class="ms-2" style="font-size: 11px;">
                                            {{ item_detail.university_abbreviation }}
                                        </span>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12 d-none">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-block font-bold text-pink block-ellipsis">Data Perkembangan Keterimaan
                                    SNBP</div>
                            </div>
                            <div class="card-body">
                                <div class="d-block" style="height:200px;">
                                    <BarChart :chart-data="statistic_acceptance" :height="'200px'" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 mb-3">
                        <div class="card bg-card-trans-2 h-100 m-0">
                            <div class="card-header">
                                <div class="d-block font-bold text-pink block-ellipsis">Jumlah Pendaftar Universitas
                                </div>
                            </div>
                            <div class="card-body">
                                <div v-if="fetch_university" class="text-muted">
                                    <p>Loading... <i class="fa fa-spin fa-spinner"></i> </p>
                                </div>

                                <div class="chart-custom" v-if="(!fetch_university && statistic_university.length > 0)"> 
                                    <div class="cc-item d-flex align-items-center" v-for="(item, index) in statistic_university" :key="index">
                                        <div class="cc-title flex-shrink-0 font-bold">{{ item.abbreviation }}</div>
                                        <div class="cc-number d-block mx-2 font-bold">{{ item.total_data }}</div>
                                        <div class="cc-progress w-100 ml-3">
                                            <div class="progress">
                                                <div class="progress-bar" :style="{ width: (item.total_data / 22 * 100) + '%', backgroundColor: item.bgcolor }"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="(!fetch_university && statistic_university.length < 1)"> 
                                    <div class="d-block text-center py-4"><div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div><div class="d-block text-sm text-muted">Data tidak tersedia</div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <div class="card bg-card-trans-2 h-100 m-0">
                            <div class="card-header">
                                <div class="d-block font-bold text-pink block-ellipsis">Perkembangan Proses SNBP Terbaru</div>
                            </div>
                            <div class="card-body" v-if="fetch_snbp">
                                <p>Loading... <i class="fa fa-spin fa-spinner"></i> </p>
                            </div>
                            <div class="card-body" v-if="!fetch_snbp">
                                <div class="col-custom">
                                    <div class="col-item" v-for="(label, index) in statistic_snbp.labels" :key="index">
                                        <div class="d-block text-center font-bold text-sm">{{ label }}</div>
                                        <div class="d-block text-center col-number" :style="{ color: statistic_snbp.datasets[0].backgroundColor[index] }">{{ statistic_snbp.datasets[0].data[index] }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="d-block">
            <div class="container-fluid">
                <div class="d-flex align-items-center justify-content-between mb-4">
                    <div class="d-block font-bold text-pink block-ellipsis">Jumlah Pendaftar Jurusan</div>
                    <div class="show-767">
                        <div class="d-flex align-items-center" style="gap:6px;">
                            <button type="button" class="swiper-nav-btn-mobile swiper-nav-btn-prev prevUniv shadow"  @click="prevSlide">
                                <div class="inner"><i class="fa-solid fa-angle-left m-0"></i></div>
                            </button>
                            <button type="button" class="swiper-nav-btn-mobile swiper-nav-btn-next nextUniv shadow"  @click="nextSlide">
                                <div class="inner"><i class="fa-solid fa-angle-right m-0"></i></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper container-fluid mb-5">
                <div class="swiper-wrapper">
                    <div class="swiper-slide h-auto" v-for="(item, index) in statistic_major" :key="index">
                        <!-- Isi card major Anda di sini -->
                        <div class="card bg-white text-dark h-100 m-0 overflow-hidden">
                            <div class="card-body pb-0 border-bottom">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="d-block me-3">
                                        <div class="avatar avatar-sm">
                                            <span class="avatar-title rounded-circle bg-neon-green text-dark">
                                                <i class="fa-solid fa-graduation-cap m-0 fa-lg"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden">
                                        <div class="d-block h3 font-bold m-0 block-ellipsis">{{ item.university_name }}
                                        </div>
                                        <div class="d-block text-muted">{{ item.major.length }} Jurusan terdaftar</div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body pt-3" style="height:280px;overflow-y:auto;">
                                <div class="d-block">
                                    <ul class="list-group list-group-flush">
                                        <li v-for="(itemDetail, indexDetail) in item.major" :key="indexDetail"
                                            class="list-group-item px-0 py-2">
                                            <div class="d-flex justify-content-between overflow-hidden">
                                                <div class="block-ellipsis">{{ itemDetail.name }}</div>
                                                <div class="ms-3 font-bold">{{ itemDetail.total_data }}</div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
                <div class="hide-767">
                    <button type="button" class="swiper-nav-btn swiper-nav-btn-prev prevUniv shadow"  @click="prevSlide">
                        <div class="inner"><i class="fa-solid fa-angle-left m-0"></i></div>
                    </button>
                    <button type="button" class="swiper-nav-btn swiper-nav-btn-next nextUniv shadow"  @click="nextSlide">
                        <div class="inner"><i class="fa-solid fa-angle-right m-0"></i></div>
                    </button>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import DoughnutChart from '../../components/chart/Doughnut.vue'
    import BarChart from '../../components/chart/Bar.vue'
    import Swiper from 'swiper';

    export default {
        components: {
            DoughnutChart,
            BarChart
        },
        data() {
            return {
                swiper: null,
                fetch_student: false,
                fetch_graduation: false,
                fetch_acceptance: false,
                fetch_university: false,
                fetch_snbp: false,
                fetch_major: false,
                school_info: [],
                statistic_student: [],
                statistic_graduation: [],
                statistic_acceptance: [],
                statistic_university: [],
                statistic_snbp: [],
                statistic_major: [],
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true
                        }
                    },
                    scales: {
                        r: {
                            pointLabels: {
                                font: {
                                    size: 14
                                }
                            },
                            ticks: {
                                display: false
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            }
                        }
                    },
                }
            }
        },
        created() {
            this.getStatisticStudent();
            this.getStatisticGraduation();
            // this.getStatisticAcceptance();
            this.getStatisticUniversity();
            this.getStatisticSNBP();
            this.getStatisticMajor();
        },
        mounted() {
            this.swiper = new Swiper('.swiper', {
                slidesPerView: 1.2,
                spaceBetween: 12,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1.2,
                        spaceBetween: 12,
                    },
                    768: {
                        slidesPerView: 2.4,
                        spaceBetween: 18,
                    },
                    1024: {
                        slidesPerView: 3.5,
                        spaceBetween: 20,
                    },
                },
            });
        },
        beforeDestroy() {
            if (this.swiper) {
                this.swiper.destroy();
            }
        },
        methods: {
            goToPage: function (params = "") {
                this.$router.push({
                    name: params
                })
            },
            getStatisticStudent: function () {
                let uri = process.env.VUE_APP_APIHOST + 'dashboard/statistic-student';

                this.fetch_student = true;
                this.$http.get(uri).then(res => {
                    this.fetch_student = false;
                    this.school_info = res.data.school_info;
                    this.statistic_student = res.data.statistic_student;
                });
            },
            getStatisticGraduation: function () {
                let uri = process.env.VUE_APP_APIHOST + 'dashboard/statistic-graduation';

                this.fetch_graduation = true;
                this.$http.get(uri).then(res => {
                    this.fetch_graduation = false;
                    this.statistic_graduation = res.data;
                });
            },
            getStatisticAcceptance: function () {
                let uri = process.env.VUE_APP_APIHOST + 'dashboard/statistic-acceptance';

                this.fetch_acceptance = true;
                this.$http.get(uri).then(res => {
                    this.fetch_acceptance = false;
                    this.statistic_acceptance = res.data;
                });
            },
            getStatisticUniversity: function () {
                let uri = process.env.VUE_APP_APIHOST + 'dashboard/statistic-university-list';

                this.fetch_university = true;
                this.$http.get(uri).then(res => {
                    this.fetch_university = false;
                    this.statistic_university = res.data;
                });
            },
            getStatisticSNBP: function () {
                let uri = process.env.VUE_APP_APIHOST + 'dashboard/statistic-snbp';

                this.fetch_snbp = true;
                this.$http.get(uri).then(res => {
                    this.fetch_snbp = false;
                    this.statistic_snbp = res.data;
                });
            },
            getStatisticMajor: function () {
                let uri = process.env.VUE_APP_APIHOST + 'dashboard/statistic-major';

                this.fetch_major = true;
                this.$http.get(uri).then(res => {
                    this.fetch_major = false;
                    this.statistic_major = res.data;
                });
            },
            prevSlide() {
                if (this.swiper) {
                    this.swiper.slidePrev();
                }
            },
            nextSlide() {
                if (this.swiper) {
                    this.swiper.slideNext();
                }
            },            
        }
    }
</script>
